import React from "react";
import PropTypes from "prop-types";

import { Box, Headline, Flex, Surface } from "@mm/ui";
import { useViewport } from "@core/theme";

import { PageHeader, PageFooter } from "components/organisms";
import { StandardPageTemplate } from "components/templates";
import { Loading } from "components/molecules";

import { Breadcrumb } from "components/atoms";

import Sections from "../sections";

import PageSections from "../PageSections";

const Landingpage = ({ page, voucherCode }) => {
  const viewport = useViewport();

  if (!page) {
    return <Loading variant="home" />;
  }
  // Check if page is active.
  const isPageActive = page.active;

  if (!isPageActive) {
    window.location.href = "/";
  }

  const PageHeadline = ({ data }) => {
    const { breadcrumb, headline, isBreadcrumbVisible, isHeadlineVisible } =
      data;

    return (
      <>
        {(isBreadcrumbVisible || isHeadlineVisible) && (
          <Box mt={6}>
            <Surface variant="narrow">
              <Flex
                flexDirection={
                  viewport.lessThan.md ? "column-reverse" : "column"
                }
              >
                {isHeadlineVisible && (
                  <Headline variant="h1" color="brand.primary">
                    {headline}
                  </Headline>
                )}

                {isBreadcrumbVisible && (
                  <Box mb={6}>
                    <Breadcrumb items={breadcrumb} />
                  </Box>
                )}
              </Flex>
            </Surface>
          </Box>
        )}
      </>
    );
  };

  if (isPageActive) {
    return (
      <StandardPageTemplate
        header={<PageHeader key="PageHeader" itemCount={1} />}
        sections={[
          <PageHeadline key="PageHeadline" data={page} />,
          <PageSections
            key="PageSections"
            sections={page.sections}
            variant={page.siteType}
            voucherCode={voucherCode}
          />,
          <Sections.RichSEOSection key="RichSEOSection" />,
        ]}
        footer={<PageFooter key="PageFooter" />}
      />
    );
  }
  return null;
};

Landingpage.propTypes = {
  // Data response from ".../page?siteType=startpage/..."
  page: PropTypes.shape({}).isRequired,
  voucherCode: PropTypes.string,
};

Landingpage.defaultProps = {
  voucherCode: "",
};

export default Landingpage;
